import { TextField } from "@material-ui/core";

const _spacing = "10px";

const RqForm = props => {
  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  return (
    <div
      data-testid="rq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <div
        id="group1"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="vin-id"
          label="Vehicle Identification Number"
          value={props?.queryState?.vin || ""}
          onChange={handleChange}
          name="vin"
          style={{ width: "45%" }}
          helperText="No dashes or spaces"
        />
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="make-id"
          label="Make (Optional)"
          value={props?.queryState?.make || ""}
          onChange={handleChange}
          name="make"
          style={{ width: "45%" }}
        />

        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="vehicle-year-id"
          label="Vehicle Year (Optional)"
          type="number"
          value={props?.queryState?.vehicleYear || ""}
          onChange={handleChange}
          name="vehicleYear"
          style={{ width: "45%" }}
        />
      </div>
    </div>
  );
};

export default RqForm;
